import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  menuCategory,
  menuItems as menuItemsData,
  operator1,
} from "components/Menu/Datamenu";
import MenuListWithSidebar from "components/Menu/MenuListWithSidebar";
import CartModal from "components/Cart/CartModal";
import CartBottomBar from "components/Menu/CartBottomBar";
import servicesApi from "api/service/service.api";
import Loading from "Util/Loading";
import operatorApi from "api/operator/operator.api";

const Menu = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    console.log("Menu mounted");
    return () => console.log("Menu unmounted");
  }, []);

  const [operator, setOperator] = useState(null);
  const [menuCategories, setMenuCategories] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  const [modalItem, setModalItem] = useState(null);

  const [selectedCategoryId, setSelectedCategoryId] = useState(
    menuCategories[0]?._id,
  );

  const [isLoading, setIsLoading] = useState(true);

  const getOperatorData = async () => {
    try {
      const slug = "saigon-star";

      const { response, err } = await operatorApi.getPublicOperator(slug);

      if (response) {
        const operatorData = response.data;

        setOperator(operatorData);

        return operatorData; // ⭐ IMPORTANT
      } else {
        console.error("No operator data found");
      }
    } catch (error) {
      console.error("Error fetching operator:", error);
    }
  };

  const getMenuCategoryData = async () => {
    try {
      const { response, err } = await servicesApi.getMenuCategoryPublic();

      if (response && response.data) {
        const categories = response.data.categories;

        setMenuCategories(categories);

        if (categories.length > 0) {
          setSelectedCategoryId(categories[0]._id);
        }
      } else {
        console.error("No categories found");
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const getMenuItemsData = async (operatorId) => {
    try {
      if (!operatorId) {
        console.warn("No operatorId provided");
        return;
      }

      const { response } = await servicesApi.getFoodItemsPublic({
        operatorId,
      });

      if (response?.data?.success) {
        const original_items = response.data.foodItems;

        setMenuItems(original_items);
      }
    } catch (error) {
      console.error("Error fetching menu items:", error);
    }
  };

  // LOAD ALL DATA
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);

        // 1️⃣ Load operator first
        const operatorData = await getOperatorData();

        // 2️⃣ Then load categories + items in parallel
        await Promise.all([
          getMenuCategoryData(),
          getMenuItemsData(operatorData?._id),
        ]);
      } catch (error) {
        console.error("Error loading menu data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  // console.log({ operator });
  // console.log({ menuCategories });
  // console.log({ menuItems });

  if (isLoading) return <Loading />;

  return (
    <div className="text-text text-4xl mt-20">
      <MenuListWithSidebar
        menuCategories={menuCategories}
        menuItems={menuItems}
        selectedCategoryId={selectedCategoryId}
        setSelectedCategoryId={setSelectedCategoryId}
        setModalItem={setModalItem}
        expandedCategory={undefined} // <-- quick patch
      />{" "}
      {modalItem && (
        <CartModal item={modalItem} onClose={() => setModalItem(null)} />
      )}
      <CartBottomBar />
    </div>
  );
};

export default Menu;
